
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 8.5C15.437 8.5 8.5 15.438 8.5 24c0 8.563 6.938 15.5 15.5 15.5 8.563 0 15.5-6.938 15.5-15.5 0-8.563-6.938-15.5-15.5-15.5zm0 6a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM24 36c-3.669 0-6.956-1.663-9.156-4.262C16.019 29.524 18.319 28 21 28c.15 0 .3.025.444.069.812.262 1.662.431 2.556.431.894 0 1.75-.169 2.556-.431A1.53 1.53 0 0127 28c2.681 0 4.981 1.525 6.156 3.738C30.956 34.337 27.67 36 24 36z","fill":"#535353"}})])
          )
        }
      }
    